(function ($) {
    $(document).ready(function () {
        $('#pills-product_info .nav-item').click(function () {
            $('#pills-product_info .nav-item a').removeClass('active');
            $(this).find('a').addClass("active");
        })
    });

    const stickyElement = document.querySelector('.register-floaty');
    const header = document.querySelector('#site-header');

    if ( stickyElement ) {
        // Function to detect sticky state
        function checkStickyStatus() {
            // Calculate the element’s current distance from the top of the viewport
            const headerHeight = header.offsetHeight;
            const compareTop = headerHeight - 50;

            // console.log(compareTop, window.scrollY);

            if (compareTop > window.scrollY) {
                // Element is "sticking" (scrolling along with the page)
                stickyElement.classList.add('at-start');
                stickyElement.classList.remove('sticking');
            } else {
                // Element is at its start position
                stickyElement.classList.add('sticking');
                stickyElement.classList.remove('at-start');
            }
        }

        // Run on scroll
        window.addEventListener('scroll', checkStickyStatus);

        
        function updateStickyStatus() {
            // Get the element's height and the available viewport height
            const elementHeight = stickyElement.offsetHeight;
            const viewportHeight = window.innerHeight;

            const headerHeight = header.offsetHeight;

            console.log( 'stuck check', elementHeight, viewportHeight, headerHeight )
        
            // Toggle 'non-sticky' class if the viewport cannot fully display the element
            if (elementHeight > viewportHeight  - headerHeight - 15) {
                stickyElement.classList.add('stuck');
            } else {
                stickyElement.classList.remove('stuck');
            }
        }
        
        // Run the function on load and resize
        window.addEventListener('load', updateStickyStatus);
        window.addEventListener('resize', updateStickyStatus);
        updateStickyStatus();
    }

})(jQuery);